export type TenantNavLinkKey =
  | "courses"
  | "about"
  | "forum"
  | "messages"
  | "notifications"
  | "admin"
  | "branding"
  | "email"
  | "approvedEmails"
  | "joinRequests"
  | "accessReport"
  | "dashboard"
  | "instructor"
  | "instructorCourses";

const STAFF_ROLES = new Set(["tenant_admin", "instructor", "ta"]);

/** Role-aware top-nav keys. Labels are resolved in the UI via i18n. */
export function tenantNavLinkKeys(
  role: string | undefined,
  isAuthenticated: boolean,
): TenantNavLinkKey[] {
  // `courses` and `about` are the public pages: no session is needed to read
  // either, so a signed-out visitor sees both.
  if (!isAuthenticated) return ["courses", "about"];

  const links: TenantNavLinkKey[] = ["courses", "about", "forum", "messages", "notifications"];

  if (role === "tenant_admin") {
    links.push("admin", "branding", "email", "approvedEmails", "joinRequests", "accessReport");
  }

  if (role === "student") {
    links.push("dashboard");
    return links;
  }

  if (role && STAFF_ROLES.has(role)) {
    links.push("instructor", "instructorCourses");
  }

  return links;
}
